import experiment from 'experiment-amd'
import dsUtils from '../utils/utils'
import type {AppDefinitionId, DataItem, Pointer, PS} from '@wix/document-services-types'
import {constants} from '@wix/santa-core-utils'

const {DATA_TYPES} = constants

const CONTROLLER_TYPE = 'platform.components.AppController'
const APP_WIDGET_TYPE = 'platform.components.AppWidget'
const CONTROLLER_DATA_TYPE = 'AppController'

function isOOIController(ps: PS, componentType: string) {
    return ps.extensionAPI.appController.isOOIController(componentType)
}

function verifyController(ps: PS, controllerRef: Pointer) {
    if (experiment.isOpen('dm_moveControllerStageDataToExt')) {
        return ps.extensionAPI.appController.verifyController(controllerRef)
    }
    if (controllerRef.type === DATA_TYPES.data) {
        if (!isAppControllerData(ps.dal.get(controllerRef))) {
            throw new Error('controllerRef data type is invalid - should be an AppController')
        }
        return
    }
    const componentType = dsUtils.getComponentType(ps, controllerRef)
    if (componentType !== CONTROLLER_TYPE && componentType !== APP_WIDGET_TYPE && !isOOIController(ps, componentType)) {
        throw new Error('controllerRef component type is invalid - should be an AppController or AppWidget')
    }
}

function isAppControllerData(dataItem: DataItem) {
    return dataItem?.type === CONTROLLER_DATA_TYPE
}

function getControllerAppDefinitionId(controllerData: DataItem): AppDefinitionId | undefined {
    if (isAppControllerData(controllerData)) {
        return controllerData?.applicationId as AppDefinitionId
    }
}

export default {
    isOOIController,
    verifyController,
    isAppControllerData,
    getControllerAppDefinitionId
}
